import { Moment } from "moment";
import Utils from "../utils";
import { SyncDataModel, DataModel, SyncModel } from "./syncModel";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { IProductViewModel } from "./product.facade";

export interface IItemGoup {
  readonly id: number;
  readonly item_mappings: ReadonlyArray<number>;
}

export class ItemGroupMenuViewModel implements IItemGoup {
  public id: number;
  public sort_nr: number;
  public label_de: string;
  public label_en: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public item_mappings: number[];
  public currentPage: number;
  public productList: IProductViewModel[];
  public dislikeProductList: IProductViewModel[];
}

export class ItemGroupViewModel implements IItemGoup {
  public id: number;
  public sort_nr: number;
  public use_label: boolean;
  public label_de: string;
  public label_en: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public item_mappings: number[];
  public imagePhoto: string;
}

// Requests
export class ItemGroupSyncModel extends SyncModel {
}

// Responses
export class ItemGroupDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public release: boolean;
  public public: boolean;
  public sort_nr: number;
  public use_label: boolean;
  public label_de: string;
  public label_en: string;
  public item_mappings: number[];
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  public get last_image_update_at(): Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  public deleted: boolean;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class ItemGroupSyncDataModel extends SyncDataModel {
  public item_groups: ItemGroupDataModel[];
  public get models(): DataModel[] { return this.item_groups; }
  public DeserializeType(): void {
    this._DeserializeType(ItemGroupDataModel);
  }
}
